import { TvLocationScreen, TvResponse, TvScreen } from 'entities/TvRender/interfaces';
import { Actions } from './actions';
import {
  CHANGE_TV_SCREEN,
  GET_TV_DATA_ERROR,
  GET_TV_DATA_REQUEST,
  GET_TV_DATA_SUCCESS,
  RESET_TV_SCREEN,
} from './constants';

export type TvState = {
  currentScreen: null | TvScreen;

  loading: boolean;
  error: Error | null;
  screens: TvScreen[] | null;
  pauseData: null | TvLocationScreen;
  data: TvResponse;
};

const initialState: TvState = {
  currentScreen: null,

  loading: false,
  error: null,
  screens: null,
  pauseData: null,
  data: {
    frequency: 6,
    locations: [],
    logoUrl: null,
    customScreens: null,
  },
};

export const tvPanelReducer = (state: TvState = initialState, action: Actions) => {
  switch (action.type) {
    case CHANGE_TV_SCREEN: {
      return {
        ...state,
        currentScreen: action.payload,
      };
    }
    case GET_TV_DATA_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case GET_TV_DATA_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload,
        pauseData: action.pauseData,
        screens: action.screens,
        currentScreen: action.currentScreen,
      };
    }
    case GET_TV_DATA_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case RESET_TV_SCREEN: {
      return { ...initialState };
    }
    default: {
      return state;
    }
  }
};
